import { jsx } from "react/jsx-runtime";
import { cx, css } from "@/styled-system/css";
import { resolveSpacing } from "../../utils/token-migration/migrate-responsive.esm.js";
const basePictureClass = css({
  display: "inline-block",
  lineHeight: 0
});
const Picture = ({
  margin,
  marginTop,
  marginBottom,
  marginLeft,
  marginRight,
  className,
  children,
  ...rest
}) => {
  const spacingCss = {};
  const resolvedMargin = resolveSpacing(margin);
  if (resolvedMargin) {
    spacingCss.marginBlockStart = resolvedMargin;
    spacingCss.marginBlockEnd = resolvedMargin;
    spacingCss.marginInlineStart = resolvedMargin;
    spacingCss.marginInlineEnd = resolvedMargin;
  }
  const resolvedMarginTop = resolveSpacing(marginTop);
  if (resolvedMarginTop) spacingCss.marginBlockStart = resolvedMarginTop;
  const resolvedMarginBottom = resolveSpacing(marginBottom);
  if (resolvedMarginBottom) spacingCss.marginBlockEnd = resolvedMarginBottom;
  const resolvedMarginLeft = resolveSpacing(marginLeft);
  if (resolvedMarginLeft) spacingCss.marginInlineStart = resolvedMarginLeft;
  const resolvedMarginRight = resolveSpacing(marginRight);
  if (resolvedMarginRight) spacingCss.marginInlineEnd = resolvedMarginRight;
  return /* @__PURE__ */ jsx("picture", { className: cx(basePictureClass, css(spacingCss), className), ...rest, children });
};
export {
  Picture as default
};
